import { CSSProperties } from 'react';

export const ARROW_TYPES = {
  POINTED_ARROW: 1,
  POINTED_ARROW_WITH_TAIL: 2,
  ROUNDED_POINTED_ARROW_WITH_TAIL: 3,
  TRIANGLE_ARROW: 4,
  TEXT_MESSAGE_ARROW: 5,
} as const;

type PropsType = {
  width?: string | number;
  height?: string | number;
  color?: string;
  stroke?: string;
  strokeWidth?: number;

  /** Defined as degrees */
  rotate?: number;

  arrowType?: Values<typeof ARROW_TYPES>;
  overrideStyle?: CSSProperties;
  onClick?: () => void;
};

// all arrows are default to most commonly used width & height

const Arrow = ({
  width,
  height,
  color = '#000',
  stroke,
  strokeWidth,
  rotate = 0,
  overrideStyle = {},
  arrowType = ARROW_TYPES.POINTED_ARROW,
  onClick,
}: PropsType) => {
  switch (arrowType) {
    case ARROW_TYPES.POINTED_ARROW:
      return (
        <svg
          width={width || '12px'}
          height={height || '12px'}
          viewBox="0 0 6 10"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            transform: `rotate(${rotate}deg)`,
            transition: 'all 0.25s',
            ...overrideStyle,
          }}
          onClick={onClick}
        >
          <path
            d="M1 1l4 4.01L1 9"
            stroke={color}
            strokeWidth={strokeWidth || '1.5'}
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case ARROW_TYPES.POINTED_ARROW_WITH_TAIL:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width || '10px'}
          height={height || '10px'}
          viewBox="0 0 16 16"
          style={{
            transform: `rotate(${rotate}deg)`,
            transition: 'all 0.25s',
            ...overrideStyle,
          }}
          onClick={onClick}
        >
          <g fill="none" fillRule="evenodd">
            <path
              fill={color}
              d="M16 7H3.8l5.6-5.6L8 0 0 8l8 8 1.4-1.4L3.8 9H16z"
            />
            <path d="M-4-4h24v24H-4z" />
          </g>
        </svg>
      );
    case ARROW_TYPES.TRIANGLE_ARROW:
      return (
        <svg
          width={width || '8px'}
          height={height || '5px'}
          viewBox="0 0 8 5"
          style={{
            transform: `rotate(${rotate}deg)`,
            transition: 'all 0.25s',
            ...overrideStyle,
          }}
          onClick={onClick}
        >
          <g fill="none" fillRule="evenodd">
            <path d="M-4-6h16v16H-4z" />
            <path
              d="M1 0a1.003 1.003 0 0 0-.71 1.71l3 3c.18.18.43.29.71.29.28 0 .53-.11.71-.29l3-3A1.003 1.003 0 0 0 7 0H1z"
              fill={color}
              stroke={stroke}
              strokeWidth={strokeWidth}
            />
          </g>
        </svg>
      );
    case ARROW_TYPES.ROUNDED_POINTED_ARROW_WITH_TAIL:
      return (
        <svg
          width={width || '12px'}
          height={height || '12px'}
          viewBox="0 0 16 16"
          style={{
            transform: `rotate(${rotate}deg)`,
            transition: 'all 0.25s',
            ...overrideStyle,
          }}
          xmlns="http://www.w3.org/2000/svg"
          onClick={onClick}
        >
          <path
            d="M3.8 7l4.89-4.89c.392-.392.39-1.03.005-1.415C8.31.31 7.676.324 7.29.71L.71 7.29a1.01 1.01 0 0 0 0 1.42l6.58 6.58a.997.997 0 0 0 1.418.002l-.016.016a1.002 1.002 0 0 0-.001-1.417L3.8 9h11.202a1 1 0 0 0 0-2H3.8z"
            fill={color}
            fillRule="evenodd"
          />
        </svg>
      );
    case ARROW_TYPES.TEXT_MESSAGE_ARROW:
      return (
        <svg
          width={width || '16px'}
          height={height || '16px'}
          viewBox="0 0 16 16"
          style={{
            transform: `rotate(${rotate}deg)`,
            transition: 'all 0.25s',
            ...overrideStyle,
          }}
          xmlns="http://www.w3.org/2000/svg"
          onClick={onClick}
        >
          <path
            d="M15.405 7.032L1.563.115a1.078 1.078 0 0 0-1.45 1.446l2.49 5.471 5.394.966-5.394.966-2.49 5.471A1.085 1.085 0 0 0 1.074 16c.171 0 .339-.041.49-.119l13.842-6.917a1.08 1.08 0 0 0 0-1.932z"
            fill={color}
            fillRule="evenodd"
          />
        </svg>
      );
    default:
      return null;
  }
};

export default Arrow;
